import loadable from '@loadable/component'

export const collectionModule = {
  variations: {
    default: loadable(() => import('./wrapper'))
  }
}
